module.exports = __webpack_public_path__ + "img/细辛.a19bb343.jpg";